<template>
  <nav class="navbar" v-click-outside="closeAll">

    <div class="left">
      <router-link to="/" class="logo">RAPTORIS</router-link>

      <div class="nav-links desktop">
        <router-link :to="localizedRoute('About')">{{ $t('menu.about') }}</router-link>
        <router-link :to="localizedRoute('Services')">{{ $t('menu.services') }}</router-link>
        <router-link :to="localizedRoute('Portfolio')">{{ $t('menu.portfolio') }}</router-link>
        <router-link :to="localizedRoute('Blog')">{{ $t('menu.blog') }}</router-link>
        <router-link :to="localizedRoute('Contact')">{{ $t('menu.contact') }}</router-link>
      </div>
    </div>

    <div class="right">

      <!-- CTA PRINCIPAL -->
      <!-- La navbar no tenía ninguna llamada a la acción persistente (hallazgo C-6). -->
      <!-- Manda al formulario de contacto. El botón de WhatsApp es aparte (flotante, App.vue). -->
      <router-link class="nav-cta desktop" :to="localizedRoute('Contact')">
        {{ $t('menu.cta') }}
      </router-link>

      <!-- LANGUAGE DROPDOWN -->
      <div class="lang-wrapper" ref="langWrapper">

        <button class="lang-btn" @click="toggleLang" :aria-expanded="langOpen" aria-label="Seleccionar idioma">
          <svg aria-hidden="true" fill="none" stroke-width="1.5" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="m10.5 21 5.25-11.25L21 21m-9-3h7.5M3 5.621a48.474 48.474 0 0 1 6-.371m0 0c1.12 0 2.233.038 3.334.114M9 5.25V3m3.334 2.364C11.176 10.658 7.69 15.08 3 17.502m9.334-12.138c.896.061 1.785.147 2.666.257m-4.589 8.495a18.023 18.023 0 0 1-3.827-5.802" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <span class="lang-current">{{ currentLangLabel }}</span>
          <svg class="chevron" :class="{ rotated: langOpen }" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 4l4 4 4-4" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>

        <div class="lang-dropdown" :class="{ open: langOpen }">
          <button
            class="lang-option"
            :class="{ active: $i18n.locale === 'es' }"
            @click="setLang('es')"
          >
            Español
          </button>
          <button
            class="lang-option"
            :class="{ active: $i18n.locale === 'en' }"
            @click="setLang('en')"
          >
            English
          </button>
        </div>

      </div>

      <!-- HAMBURGER -->
      <button class="menu-btn" @click="toggleMenu" :aria-expanded="menuOpen" :aria-label="menuOpen ? 'Cerrar menú' : 'Abrir menú'">
        ☰
      </button>

    </div>

    <!-- MOBILE MENU -->
    <div class="mobile-menu" :class="{ active: menuOpen }">
      <router-link @click="closeAll" :to="localizedRoute('About')">{{ $t('menu.about') }}</router-link>
      <router-link @click="closeAll" :to="localizedRoute('Services')">{{ $t('menu.services') }}</router-link>
      <router-link @click="closeAll" :to="localizedRoute('Portfolio')">{{ $t('menu.portfolio') }}</router-link>
      <router-link @click="closeAll" :to="localizedRoute('Blog')">{{ $t('menu.blog') }}</router-link>
      <router-link @click="closeAll" :to="localizedRoute('Contact')">{{ $t('menu.contact') }}</router-link>
      <router-link class="mobile-cta" @click="closeAll" :to="localizedRoute('Contact')">{{ $t('menu.cta') }}</router-link>
    </div>

  </nav>
</template>

<script>
export default {
  name: "NavbarComponent",

  directives: {
    clickOutside: {
      mounted(el, binding) {
        el._clickOutsideHandler = (event) => {
          if (!el.contains(event.target)) {
            binding.value();
          }
        };
        document.addEventListener("click", el._clickOutsideHandler);
      },
      unmounted(el) {
        document.removeEventListener("click", el._clickOutsideHandler);
      }
    }
  },

  data() {
    return {
      menuOpen: false,
      langOpen: false,

      routeMap: {
        'About':                       { es: '/nosotros',                                          en: '/about' },
        'Contact':                     { es: '/contacto',                                          en: '/contact' },
        'Services':                    { es: '/servicios',                                         en: '/services' },
        'Faqs':                        { es: '/faqs',                                              en: '/faqs' },
        'DigitalOperationsManagement': { es: '/servicios/diseno-paginas-web',            en: '/services/web-design' },
        'DigitalSales':                { es: '/servicios/tiendas-en-linea',                        en: '/services/online-stores' },
        'SupportOptimization':         { es: '/servicios/soporte-aplicaciones',        en: '/services/application-support' },
        'BrandingIdentity':            { es: '/servicios/branding-identidad-marca',                en: '/services/branding-brand-identity' },
        'ServiceFormDOM':              { es: '/servicios/diseno-paginas-web/formulario', en: '/services/web-design/form' },
        'ServiceFormSales':            { es: '/servicios/tiendas-en-linea/formulario',             en: '/services/online-stores/form' },
        'ServiceFormSupport':          { es: '/servicios/soporte-aplicaciones/formulario', en: '/services/application-support/form' },
        'ServiceFormBranding':         { es: '/servicios/branding-identidad-marca/formulario',     en: '/services/branding-brand-identity/form' },
        'PrivacyPolicy':               { es: '/aviso-privacidad',                                  en: '/privacy-policy' },
        'Portfolio':                   { es: '/portafolio',                                        en: '/portfolio' },
        'Blog':                        { es: '/blog',                                              en: '/blog' },
        'BlogSignals':                 { es: '/blog/5-senales-sitio-web-clientes',       en: '/blog/website-warning-signs-losing-customers' },
      }
    };
  },

  computed: {
    currentLangLabel() {
      return this.$i18n.locale === 'es' ? 'ES' : 'EN';
    }
  },

  watch: {
    '$i18n.locale'(newLocale) {
      const mapped = this.routeMap[this.$route.name];
      if (mapped && mapped[newLocale]) {
        this.$router.replace(mapped[newLocale]);
      }
    },

  },

  methods: {
    toggleMenu() { this.menuOpen = !this.menuOpen; },
    toggleLang()  { this.langOpen = !this.langOpen; },
    closeAll()    { this.menuOpen = false; this.langOpen = false; },

    localizedRoute(name) {
      const mapped = this.routeMap[name];
      if (mapped) return mapped[this.$i18n.locale] || mapped['es'];
      return '/';
    },

    setLang(locale) {
      this.$i18n.locale = locale;
      this.langOpen = false;

      const currentName = this.$route.name;
      const mapped = this.routeMap[currentName];

      if (mapped && mapped[locale]) {
        this.$router.replace(mapped[locale]);
      }
    }
  }
};
</script>

<style scoped>

/* NAVBAR */
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 1rem 2rem;
  background: linear-gradient(135deg, #0a0b06, #141a0c 55%, #1f2712);
  box-shadow: 0 10px 25px rgba(0,0,0,.2);
  border-bottom: 1px solid rgba(151, 165, 101, .18);

  position: relative;
  z-index: 1000;
}

.navbar::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(220, 223, 210, .35), transparent);
  pointer-events: none;
}

/* LEFT */
.left {
  display: flex;
  align-items: center;
  gap: 2rem;
}

/* RIGHT */
.right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* LOGO: texto con look metálico/plateado (brillo que recorre el texto) */
.logo {
  background: linear-gradient(110deg, #787d6c 15%, #dcdfd2 35%, #ffffff 48%, #dcdfd2 60%, #97a565 75%, #787d6c 90%);
  background-size: 220% 100%;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-decoration: none;
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: 2px;
  animation: logoShimmer 3.8s linear infinite;
}

@keyframes logoShimmer {
  0%   { background-position: 220% 0; }
  100% { background-position: -220% 0; }
}

@media (prefers-reduced-motion: reduce) {
  .logo {
    animation: none;
  }
}

/* DESKTOP LINKS */
.nav-links {
  display: flex;
  gap: 1.8rem;
}

.nav-links a {
  color: white;
  text-decoration: none;
  font-size: 1.1rem;
  position: relative;
}

.nav-links a::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -4px;
  width: 0;
  height: 2px;
  background: linear-gradient(90deg, #97a565, #dcdfd2);
  transition: .3s;
}

.nav-links a:hover::after {
  width: 100%;
}

/* LANGUAGE WRAPPER */
.lang-wrapper {
  position: relative;
}

/* LANGUAGE BUTTON */
.lang-btn {
  display: flex;
  align-items: center;
  gap: 0.4rem;

  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;

  color: rgba(255, 255, 255, 0.85);
  font-size: 0.82rem;
  font-weight: 500;
  letter-spacing: 0.5px;

  padding: 0.38rem 0.7rem;
  cursor: pointer;

  transition: background 0.2s, border-color 0.2s;
}

.lang-btn:hover {
  background: rgba(255, 255, 255, 0.12);
  border-color: rgba(255, 255, 255, 0.22);
}

.lang-btn svg:first-child {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.lang-current {
  min-width: 18px;
  text-align: center;
}

/* CHEVRON */
.chevron {
  transition: transform 0.25s ease;
}

.chevron.rotated {
  transform: rotate(180deg);
}

/* DROPDOWN */
.lang-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;

  background: #141a0c;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.35);
  overflow: hidden;

  min-width: 130px;

  /* Animación */
  opacity: 0;
  transform: translateY(-6px);
  pointer-events: none;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.lang-dropdown.open {
  opacity: 1;
  transform: translateY(0);
  pointer-events: all;
}

/* OPCIONES */
.lang-option {
  display: block;
  width: 100%;

  padding: 0.65rem 1rem;

  background: none;
  border: none;
  cursor: pointer;

  color: rgba(255, 255, 255, 0.75);
  font-size: 0.88rem;
  text-align: left;

  transition: background 0.15s, color 0.15s;
}

.lang-option:hover {
  background: rgba(255, 255, 255, 0.06);
  color: white;
}

.lang-option.active {
  color: #dde1cc;
  font-weight: 600;
}

.lang-option + .lang-option {
  border-top: 1px solid rgba(255, 255, 255, 0.06);
}

/* CTA PRINCIPAL (hallazgo C-6) */
.nav-cta {
  display: inline-flex;
  align-items: center;
  padding: .55rem 1.1rem;
  border-radius: 999px;
  background: #97a565;
  color: #10130a;
  font-weight: 600;
  font-size: .92rem;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
  transition: background .18s ease, transform .18s ease;
}

.nav-cta:hover,
.nav-cta:focus-visible {
  background: #b4c37f;
  transform: translateY(-1px);
}

.nav-cta:focus-visible {
  outline: 2px solid #e8ecd8;
  outline-offset: 2px;
}

.mobile-cta {
  margin: .75rem 2rem 1.25rem;
  padding: .85rem 1.25rem !important;
  border-top: none !important;
  border-radius: 999px;
  background: #97a565;
  color: #10130a !important;
  font-weight: 600;
  text-align: center;
}

/* HAMBURGER */
.menu-btn {
  display: none;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  background: none;
  border: none;
  color: white;
  font-size: 1.7rem;
  line-height: 1;
  cursor: pointer;
}

/* MOBILE MENU */
.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;

  width: 100%;
  background: #141a0c;

  display: flex;
  flex-direction: column;

  max-height: 0;
  overflow: hidden;
  transition: .3s ease;
}

.mobile-menu.active {
  max-height: 420px;
}

.mobile-menu a {
  color: white;
  text-decoration: none;
  padding: 1rem 2rem;
  border-top: 1px solid rgba(255,255,255,.08);
}

/* TABLET + PHONE */
@media (max-width: 768px) {

  .desktop {
    display: none;
  }

  .menu-btn {
    display: flex;
  }

  .logo {
    font-size: 1.25rem;
  }

  .navbar {
    padding: 1rem;
  }

  .lang-btn {
    font-size: 0.78rem;
    padding: 0.32rem 0.55rem;
  }
}

</style>